// eslint-disable-next-line import/prefer-default-export
export function isMac(): boolean {
	return navigator.userAgent.indexOf('Mac OS X') > -1;
}
